import axios from "axios"
import { qsStringify } from "src/utilities/helper"
import appService from "src/AppService"

const historySession: any = {
    key: null,
    target: null,
    cancel: () => {
        const key = historySession.key
        const target = historySession.target
        if (key && target) {
            const rb = {
                sessionKey: key,
                TargetView: target
            }
            historySession.key = null
            historySession.target = null
            axios.post(process.env.REACT_APP_AREA51_BASEURL + "/api/session/cancel", qsStringify(rb), appService.axiosHeaders)
                .then(res => {
                    //console.log("History Session Canceled")
                })
                .catch(err => {
                    //console.log(err)
                })
        }else{
            historySession.key = null
            historySession.target = null
        }
    }
}
export default historySession